import type { OrderTabKey } from '@/features/group/order-tabs'
import type { GroupOrderStatus } from '@/features/group/schema'

const tabs: Record<GroupOrderStatus, OrderTabKey> = {
  UNPAID: 'unpaid',
  BILLED: 'billed',
  IN_PROCESS: 'processing',
  SHIPPED: 'shipped',
  COMPLETED: 'done',
  CANCELLED: 'done',
  UNKNOWN: 'unpaid',
}

export const DASHBOARD_ORDERS_PAGE_SIZE = 4

export function dashboardOrderTab(status: GroupOrderStatus, hasUnclearProduct = true): OrderTabKey {
  if (status === 'UNPAID' && !hasUnclearProduct) return 'billed'
  return tabs[status]
}
